import React from 'react';
import MultiChartCard from './components/MultiChartCard';

const MultiChartLayout  = (index, coin, oData, pData) => {
        return <MultiChartCard index_label={index} coin_label={index} oData={oData} pData={pData} />
}

export default React.memo(MultiChartLayout);
